export interface ClockControl {
  setInterval: (milliseconds: number) => void;
}

export const clock = (advance: (clockControl: ClockControl) => void) => {
  let timer: any;
  let intervalMilliseconds = 1000;
  let mustRestartTimer = false;
  const clockControl: ClockControl = {
    setInterval(milliseconds: number) {
      intervalMilliseconds = milliseconds;
      mustRestartTimer = true;
    }
  };
  
  function tick() {
    advance(clockControl);
    if (mustRestartTimer) {
      mustRestartTimer = false;
      startOrRestartTimer();
    }
  }
  function startOrRestartTimer() {
    timer && clearInterval(timer);
    timer = setInterval(tick, intervalMilliseconds);
  }
  startOrRestartTimer();
};